import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent {
  currentDate = new Date().toLocaleDateString();
}


// WEBPACK FOOTER //
// ./src/app/privacy-policy/privacy-policy.component.ts